export type PortalShop = {
  id: string;
  name: string;
  slug: string;
  isNewCustomerPortalEnabled?: boolean | null;
  storefrontUrl?: string | null;
  hasExchanges?: boolean | null;
  hasExchangeCredit?: boolean | null;
  hasGiftCode?: boolean | null;
  isActive?: boolean | null;
};

export type TriState = "all" | "on" | "off";

export type PortalFilters = {
  search: string;
  portal: TriState;
  exchanges: TriState;
  exchangeCredit: TriState;
  giftCode: TriState;
  active: TriState;
};

export const INITIAL_PORTAL_FILTERS: PortalFilters = {
  search: "",
  portal: "all",
  exchanges: "all",
  exchangeCredit: "all",
  giftCode: "all",
  active: "on",
};

export function nextTriState(state: TriState): TriState {
  if (state === "all") return "on";
  if (state === "on") return "off";
  return "all";
}

function matchesTriState(state: TriState, value: boolean): boolean {
  return state === "all" || (state === "on") === value;
}

function matchesSearch(shop: PortalShop, search: string): boolean {
  const q = search.trim().toLowerCase();

  return (
    !q ||
    shop.name.toLowerCase().includes(q) ||
    shop.slug.toLowerCase().includes(q)
  );
}

export function filterPortalShops(
  shops: PortalShop[],
  filters: PortalFilters,
): PortalShop[] {
  return shops.filter(
    (shop) =>
      matchesSearch(shop, filters.search) &&
      matchesTriState(
        filters.portal,
        shop.isNewCustomerPortalEnabled ?? false,
      ) &&
      matchesTriState(filters.exchanges, shop.hasExchanges ?? false) &&
      matchesTriState(
        filters.exchangeCredit,
        shop.hasExchangeCredit ?? false,
      ) &&
      matchesTriState(filters.giftCode, shop.hasGiftCode ?? false) &&
      matchesTriState(filters.active, shop.isActive ?? true),
  );
}
